<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.SideBySideMediaContentSlice>());
</script>

<template>
  <Bounded
      as="section"
      y-padding="base"
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-sbs', { 'pa-sbs--image-right': slice.variation === 'imageRight' }]"
  >
    <div class="pa-sbs__grid">
      <!-- Media side -->
      <div class="pa-sbs__media">
        <div
            v-for="(item, index) in slice.primary.media"
            :key="index"
            class="pa-sbs__media-item pa-img-hover"
        >
          <PrismicImage
              :field="item.image"
              class="pa-sbs__media-image"
          />
        </div>
      </div>

      <!-- Content side -->
      <div class="pa-sbs__content">
        <div class="pa-sbs__content-heading">
          <PrismicRichText :field="slice.primary.heading" />
        </div>
        <div class="pa-sbs__content-body">
          <PrismicRichText :field="slice.primary.content" />
        </div>
        <div v-if="slice.primary.cta_button && ('id' in slice.primary.cta_button || 'url' in slice.primary.cta_button)">
          <TrackedPrismicLink :field="slice.primary.cta_button" :track="slice.primary.cta_track_event" class="pa-btn pa-btn--primary" />
        </div>
      </div>
    </div>
  </Bounded>
</template>
